import serverError from '../../images/server-error.png';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CreatePassword } from '../create-password/create-password.component';
import { Login } from '../login/login.component';
import { Main } from '../main/main.component';
import { NotFound } from '../not-found/not-found.component';
import { ErrorPage } from '@recargas-dominicanas/core/components';
import { Signup } from '../signup/signup.component';
import { Home } from '../home/home.component';
import { Transactions } from '../transactions/transactions.component';
import { SalesReports } from '../sales-reports/sales-reports.component';
import { Sales } from '../sales/sales.component';
import { TopupBalance } from '../topup-balance/topup-balance.component';
import { Help } from '../help/help.component';
import { Settings } from '../settings/settings.component';
import { ContactSales } from '../contact-sales/contact-sales.component';
import { Onboarding } from '../onboarding/onboarding.component';
import { HowToBuyBalance } from '../how-to-buy-balance/how-to-buy-balance.component';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/iniciar-sesion' element={<Login/>} />
        <Route path='/crear-cuenta' element={<Signup/>} />
        <Route path='/create-password/:token' element={<CreatePassword/>}/>
        <Route path='/pagina-no-encontrada' element={<NotFound/>}/>
        <Route path='/onboarding' element={<Onboarding/>}/>
        <Route path='/como-comprar-balance' element={<HowToBuyBalance/>}/>
        <Route path='/contactar-ventas' element={<ContactSales/>}/>
        <Route path='/error' element={<ErrorPage image={serverError}/>}/>
        <Route path='/' element={<Main/>}>
          <Route index element={<Home/>}/>
          <Route path='/transacciones' element={<Transactions/>}/>
          <Route path='/cierre-de-ventas' element={<SalesReports/>}/>
          <Route path='/ventas' element={<Sales/>}/>
          <Route path='/comprar-balance' element={<TopupBalance/>}/>
          <Route path='/ayuda' element={<Help/>}/>
          <Route path='/configuracion' element={<Settings/>}/>
        </Route>
        <Route path='*' element={<NotFound/>} />
      </Routes>
    </BrowserRouter>
  );
}
